import React from "react";
import {Button} from "antd";
import Icon, {EditOutlined} from "@ant-design/icons";
import DragDrop from "../dnd/DragDrop";

import Text from "../text/Text";
import DeleteSvg from "../../asset/icon/Delete.svg";
import EditFragment from "./EditFragment";

export default class OptionCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
        };
    }

    setIsEditing = (isEditing) => {
        this.setState({
            isEditing,
        });
    }

    render() {
        const {data, index, onMove, onChangeName, onDelete, changeEditingCount} = this.props;

        return (
            <DragDrop.Item
                index={index}
                style={{
                    height: 39,
                    display: "flex",
                    alignItems: "center",
                    borderBottom: "1px solid #D2D8DE",
                }}
                moveIndicatorStyle={{
                    flex: "none",
                    margin: "0 16px",
                }}
                move={onMove}
            >
                {
                    this.state.isEditing
                        ? (
                            <EditFragment
                                defaultValue={data.name}
                                onCancel={() => {
                                    this.setState({
                                        isEditing: false,
                                    });
                                    changeEditingCount("decrement");
                                }}
                                onCommit={(value) => {
                                    onChangeName(value, data, this.setIsEditing);
                                }}
                            />
                        )
                        : (
                            <>
                                <Text style={{flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{data.name}</Text>
                                {
                                    !data.disabled && (
                                        <React.Fragment>
                                            <Button
                                                onClick={(e) => {
                                                    this.setState({isEditing: true});
                                                    changeEditingCount("increment");
                                                }}
                                                type="link"
                                                style={{padding: 0}}
                                            >
                                                <EditOutlined />
                                            </Button>
                                            <Button
                                                onClick={e => onDelete(data)}
                                                type="link"
                                                danger
                                                style={{padding: 0, margin: "0 16px"}}
                                            >
                                                <Icon component={DeleteSvg} />
                                            </Button>
                                        </React.Fragment>
                                    )
                                }
                            </>
                        )
                   }
            </DragDrop.Item>
        );
    }
}
